import React, { useState } from "react";
import { FaUserMd, FaMinus, FaPlus, FaCapsules, FaMicroscope,FaVials, FaChartLine, FaClipboardCheck, FaIndustry, FaFlask, FaCogs, FaShieldAlt, FaDollyFlatbed, FaWarehouse } from "react-icons/fa";
import Medpalm from "../../../assests/HealthcarePLS/pharma.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        title: "Large-Scale Drug Manufacturing",
        description: "Mass production of pharmaceuticals using Good Manufacturing Practice (GMP)-certified facilities to ensure consistency, quality, and safety. This process involves raw material sourcing, formulation, large-scale synthesis, and packaging while maintaining strict regulatory compliance with global health authorities such as the FDA, EMA, and WHO."
    },
    {
        title: "Custom Formulation Development",
        description: "Designing and optimizing drug formulations tailored to specific therapeutic needs. This includes developing extended-release tablets, liquid suspensions, topical solutions, and innovative drug delivery systems to enhance bioavailability and patient adherence. Custom formulations are critical for personalized medicine and niche therapeutic applications."
    },
    {
        title: "Sterile & Injectable Drug Production",
        description: "Manufacturing injectable and biologic drugs, including vaccines, monoclonal antibodies, and insulin, under highly controlled aseptic conditions. This process requires stringent contamination control, sterile fill-finish procedures, and adherence to regulatory guidelines to ensure the highest level of safety and efficacy for intravenous, intramuscular, and subcutaneous drug delivery."
    },
    {
        title: "Process Optimization & Automation",
        description: "Improving pharmaceutical production efficiency through advanced process optimization and automation technologies. This includes implementing AI-driven quality control, robotic manufacturing systems, real-time monitoring, and continuous manufacturing techniques to reduce costs, enhance precision, and increase production scalability."
    },
    {
        title: "Regulatory Compliance & Quality Assurance",
        description: "Ensuring all pharmaceutical products meet global regulatory standards set by the FDA, EMA, and WHO. Quality assurance teams oversee Good Manufacturing Practices (GMP), conduct rigorous quality control testing, validate manufacturing processes, and manage documentation for regulatory submissions, ensuring drug safety and efficacy."
    },
    {
        title: "Supply Chain & Distribution Management",
        description: "Coordinating global logistics to ensure the efficient distribution of pharmaceuticals from manufacturing sites to healthcare providers and pharmacies. This includes managing cold chain logistics for temperature-sensitive biologics, optimizing inventory levels, preventing shortages, and complying with international trade regulations to ensure uninterrupted drug supply worldwide."
    }
];
const features = [
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "State-of-the-art drug production facilities." },
    { icon: <FaFlask className="text-[#2a627a] text-lg" />, text: "Advanced formulation technologies for high-quality drugs." },
    { icon: <FaVials className="text-[#2a627a] text-lg" />, text: "Strict quality control processes for drug safety." },
    { icon: <FaCogs className="text-[#2a627a] text-lg" />, text: "Automated manufacturing for precision and efficiency." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Compliance with global regulatory standards (GMP, FDA, EMA)." },
    { icon: <FaDollyFlatbed className="text-[#2a627a] text-lg" />, text: "Optimized supply chain management for drug distribution." }
];
const benefits = [
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Scalable production for global pharmaceutical needs." },
    { icon: <FaWarehouse className="text-[#2a627a] text-lg" />, text: "Ensures consistent drug quality and safety." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Enhances drug availability and affordability worldwide." },
    { icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />, text: "Meets stringent regulatory and safety standards." },
    { icon: <FaFlask className="text-[#2a627a] text-lg" />, text: "Advances research into more effective drug formulations." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Reduces production risks through strict quality assurance." }
];
const cmsFeatures = [
    {
        icon: <FaUserMd className="text-[#2a627a] text-lg" />,
        title: "Pharmaceutical Scientist",
        text: "Researches and develops new drug formulations for mass production."
    },
    {
        icon: <FaMicroscope className="text-[#2a627a] text-lg" />,
        title: "Quality Control Analyst",
        text: "Ensures that drugs meet safety, efficacy, and regulatory standards."
    },
    {
        icon: <FaIndustry className="text-[#2a627a] text-lg" />,
        title: "Manufacturing Engineer",
        text: "Optimizes production processes to improve efficiency and compliance."
    },
    {
        icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />,
        title: "Regulatory Compliance Officer",
        text: "Ensures adherence to FDA, EMA, and GMP guidelines in drug manufacturing."
    }
];
const PharmaceuticalManufacturing = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Pharmaceutical Manufacturing - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Ensuring high-quality, safe, and consistent production of medications through stringent processes and regulatory compliance."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Pharmaceutical Manufacturing?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Pharmaceutical manufacturing is the process of producing medications on a large scale while ensuring quality,
                            safety, and regulatory compliance. At HIKEHEALTH GS, we utilize advanced manufacturing technologies, stringent
                            quality control measures, and Good Manufacturing Practices (GMP) to develop high-quality pharmaceutical products.
                            Our goal is to ensure the consistent availability of safe and effective medications to improve global healthcare.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Pharmaceutical Manufacturing
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default PharmaceuticalManufacturing;
